/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import { makeStyles, createStyles } from "@material-ui/core";
import { TreeView } from "@material-ui/lab";
import AddBoxIcon from "@material-ui/icons/AddBox";
import IndeterminateCheckBoxIcon from "@material-ui/icons/IndeterminateCheckBox";
import { MinusSquareSvgIcon } from "./icon/MinusSquareSvgIcon";
import { CloseSquareSvgIcon } from "./icon/CloseSquareSvgIcon";
import { PlusSquareSvgIcon } from "./icon/PlusSquareSvgIcon";
import {
  PathCheckboxTreeDefs,
  PathCheckboxTreeData,
  PathCheckboxTreeNode,
} from "../../types";
import { PathCheckboxTreeItem } from "./PathCheckboxTreeItem";

/** スタイル定義 */
const useStyles = makeStyles(
  createStyles({
    root: {
      height: 264,
      flexGrow: 1,
      maxWidth: 400,
    },
    icon: {
      cursor: "pointer",
      margin: "0.25rem",
    },
  })
);

// 全てのノードIDを取得する
export const getNodeIdAll = (nodes: PathCheckboxTreeNode[]): string[] => {
  const nodeIds: string[] = [];
  const getNodeIdAllRecursive = (innerNodes: PathCheckboxTreeNode[]) => {
    innerNodes.forEach((node: PathCheckboxTreeNode) => {
      nodeIds.push(node.nodeId);
      if (node.children) {
        getNodeIdAllRecursive(node.children);
      }
    });
  };
  getNodeIdAllRecursive(nodes);
  return nodeIds;
};

interface Props {
  defs: PathCheckboxTreeDefs;
  data: PathCheckboxTreeData;
  handleChange: (newData: PathCheckboxTreeData) => void;
}

/** パスチェックボックスツリー */
export function PathCheckboxTree(props: Props) {
  const classes = useStyles();
  const { defs, data, handleChange } = props;
  const createTree = (treeNodes: PathCheckboxTreeNode[]): React.ReactNode => {
    return (
      <>
        {treeNodes.map((treeNode: PathCheckboxTreeNode) => {
          const { nodeId, value, label, children } = treeNode;
          return (
            <PathCheckboxTreeItem
              nodeId={nodeId}
              value={value}
              key={nodeId}
              label={label}
              defs={defs}
              data={data}
              handleChange={handleChange}
            >
              {children && createTree(children)}
            </PathCheckboxTreeItem>
          );
        })}
      </>
    );
  };
  const treeStructure = createTree(defs.nodes);

  //--------------------
  // コンポーネント
  return (
    <>
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <div>
          {/* 全て開くアイコン */}
          <AddBoxIcon
            className={classes.icon}
            onClick={() => {
              handleChange({
                checked: data.checked,
                expanded: getNodeIdAll(defs.nodes),
              });
            }}
          />
        </div>
        <div>
          {/* 全て閉じるアイコン */}
          <IndeterminateCheckBoxIcon
            className={classes.icon}
            onClick={() => {
              handleChange({
                checked: data.checked,
                expanded: [],
              });
            }}
          />
        </div>
      </div>
      <TreeView
        className={classes.root}
        defaultCollapseIcon={<MinusSquareSvgIcon />}
        defaultExpandIcon={<PlusSquareSvgIcon />}
        defaultEndIcon={<CloseSquareSvgIcon />}
        expanded={data.expanded}
        onNodeToggle={(_event: any, newExpanded: string[]) => {
          handleChange({
            checked: data.checked,
            expanded: newExpanded,
          });
        }}
      >
        {treeStructure}
      </TreeView>
    </>
  );
}
